import i18next from 'i18next';

i18next.addResources('en', 'Footer', {
  ABOUT: 'About',
  BLOG: 'Blog',
  PRESS: 'Press',
  CAREERS: 'Careers',
  FINANCING: 'Financing',
  FAQ: 'FAQ',
  SUPPORT: 'Support',
  LEGAL: 'Legal',
  PRIVACY: 'Privacy',
  TERMS_OF_USE: 'Terms',
  STAY_UPDATED: 'Stay Updated',
  FOLLOW_US: 'Follow us',
  PHONE: 'Phone',
  EMAIL_FIELD: 'Email',
  LOGO: 'Pivot fitness',
  SUBSCRIPTION_ERROR: "Couldn't subscribe. Try again later."
});
